import { useAppSelector } from "@src/reduxStore";
import { FC } from "react";
import { useIntl } from "react-intl";

const LinkToLiabilityInsuranceForm: FC = ({ children }) => {
  const config = useAppSelector(state => state.common.config);
  const intl = useIntl();

  return (
    <a
      href={intl.formatMessage(
        {
          id: "liabilityInsuranceFormUrl",
          defaultMessage:
            "{supportUrl}/hc/fi/requests/new?ticket_form_id=360000365319",
        },
        {
          supportUrl: config?.supportUrl,
        }
      )}
      target="_blank"
      rel="noreferrer noopener"
    >
      {children}
    </a>
  );
};

export default LinkToLiabilityInsuranceForm;
